import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllUserRoles } from "../server/rolesAllApi";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const AddNoticeboardLayer = () => {
  const [formValues, setFormValues] = useState({
    content: "",
    noticeboardCategory_id: "",
    role_id: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [touched, setTouched] = useState(false);
  const [roles, setRoles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const navigate = useNavigate();

  useEffect(() => {
    fetchUserRoles();
    fetchCategories();
  }, []);
  
  const fetchUserRoles = async () => {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      try {
        const reqHeader = { authorization: `Bearer ${token}` };
        const response = await getAllUserRoles("", reqHeader);
        setRoles(response.data.roles);
      } catch (error) {
        setError("Failed to fetch users.");
      } finally {
        setLoading(false);
      }
    };

    const fetchCategories = async () => {
        try {
          const token = localStorage.getItem("token");
          if (!token) {
            // console.log("Access required");
            return;
          }
          const response = await axios.get(
            `${process.env.REACT_APP_INSTITUTION_BASEURL}/nopagination-noticeboardCategory`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          setCategories(response.data.data);
          // console.log(response.data.data);
        } catch (error) {
          // console.log(error);
        }
      };

  // snackbar
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if(loading) return; // Prevent multiple submissions
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }

      // console.log(
      //   "REACT_APP_INSTITUTION_BASEURL:: ",
      //   process.env.REACT_APP_INSTITUTION_BASEURL
      // );
      const response = await axios.post(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/add-noticeboard`,
        formValues,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 201) {
        setSnackbarMessage("Created successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/noticeboard-list");
        }, 2000);
      }
    } catch (err) {
      setLoading(false);

      // Check for 400 status error
      if (err.response && err.response.status === 400) {
        setSnackbarMessage("Please fill out all required fields...");
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
      } else {
        setSnackbarMessage("Failed to create. Please try again.");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      }
    } 
  };

  return (
    <div className="row gy-4">
      <div className="col-lg-8" style={styles.cardContent(loading)}>
        <div className="card h-100">
          <div className="card-body p-24">
            <form onSubmit={handleFormSubmit}>
              <div className="mb-20">
                <label
                  htmlFor="content"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Content
                  <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className="form-control radius-8"
                  id="content"
                  placeholder="Enter Content"
                  value={formValues.content}
                  onChange={(e) => {
                   
                    const value = e.target.value;

                    if (value === "" || value.trim() !== "") {
                      setFormValues({
                        ...formValues,
                        content: value,
                      });
                    }
                  }}
                  onBlur={() => setTouched(true)} // Mark as touched when losing focus
                  required
                />
              </div>

              <div className="mb-20">
                <label
                  htmlFor="category"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Category
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  required
                  className="form-control radius-8 form-select"
                  id="category"
                  value={formValues.noticeboardCategory_id}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      noticeboardCategory_id: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select Category
                  </option>
                  {categories.map((category) => (
                    <option key={category._id} value={category._id}>
                      {category?.categoryName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-20">
                <label
                  htmlFor="role_id"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Role
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  required
                  className="form-control radius-8 form-select"
                  id="role_id"
                  value={formValues.role_id}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      role_id: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select Role
                  </option>
                  {roles.map((role) => (
                    <option key={role._id} value={role._id}>
                      {role.rolename}
                    </option>
                  ))}
                </select>
              </div>

              <div className="d-flex align-items-center justify-content-center gap-3">
                <button
                  type="button"
                  className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                  onClick={() => navigate("/noticeboard-list")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                  // onClick={handleFormSubmit}
                >
                  {loading && (
                    <div
                      className="loader-container"
                      style={styles.loaderContainer}
                    >
                      <CircularProgress />
                    </div>
                  )}
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          // variant="filled"
          // sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default AddNoticeboardLayer;
